export const GOOGLE_OAUTH_PATH = '/api/oauth-token/v1/authorization/google';
